import React from "react";
import T from "prop-types";

import { GridResult } from "2g-grid";

import useProjektyGrid from "./useProjektyGrid";

export function ProjektyGrid({ ico }) {
  const grid = useProjektyGrid({ ico });
  return <GridResult {...grid} />;
}

ProjektyGrid.propTypes = { ico: T.string };

export default React.memo(ProjektyGrid);
